/* BuiltRight YMM runtime v9.1 — native header control, homepage bar, slide-down selector,
   curated-collection routing, persistent tag filtering, two-way easysearch garage bridge.
   Data from br-ymm-data.js (window.BR_SEL / window.BR_TAGS). ES5 only.

   The header control is REAL LIQUID (snippets/br-ymm-control.liquid, rendered by
   header-icons.liquid). This file only updates its innerHTML and decides block-vs-bar
   by measurement (YMM_REBUILD_SPEC §1c). It must never create, move or anchor the
   control — JS injection into Concept's header failed three separate ways.

   v9.1: tag filtering no longer applies to VEHICLE collections. See isVehiclePath. */
(function(){'use strict';
var LSKEY='br_vehicle',UNI='nm-es-universal',GAP=14;
var ESD='easysearch-preselect-delimiter',ES_TTL=3600000;
var ES_PRE='easysearch-preselect',ES_TAG='easysearch-tag-filter';
var SEL=window.BR_SEL||{},TAGS=window.BR_TAGS||{};
var NOFILTER=['apparel','merch','gift','sticker','swag','patch','hat','shirt','rod-rig','mountech'];
/* A vehicle collection ALREADY encodes the vehicle, so tag-filtering it asks "which
   Silverado parts also fit a Raptor" — a question nobody has, and the answer is
   essentially just the universal products. Filtering stays on CATEGORY collections,
   where it earns its place. Vehicle landing pages keep clean URLs and let collection
   merchandising decide what shows. Paths are derived from BR_SEL so this list can
   never drift from the routing table. */
var VEHPATHS={};
(function(){for(var mk in SEL)for(var md in SEL[mk]){var a=SEL[mk][md];for(var i=0;i<a.length;i++){VEHPATHS[String(a[i][2]).split('?')[0].replace(/\/$/,'').toLowerCase()]=1;}}})();
function isVehiclePath(p){return !!VEHPATHS[String(p||'').split('?')[0].replace(/\/$/,'').toLowerCase()];}
function track(ev,p){try{window.dataLayer=window.dataLayer||[];var o={event:ev};if(p)for(var k in p)o[k]=p[k];window.dataLayer.push(o);if(typeof window.gtag==='function')window.gtag('event',ev,p||{});}catch(e){}}
function span(map,mk,md,y){var m=map[mk]&&map[mk][md];if(!m)return null;for(var i=0;i<m.length;i++)if(y>=m[i][0]&&y<=m[i][1])return m[i][2];return null;}
function tagFor(v){return v?span(TAGS,v.mk,v.md,parseInt(v.y,10)):null;}
function getV(){try{return JSON.parse(localStorage.getItem(LSKEY)||'null');}catch(e){return null;}}
function onCollection(){return location.pathname.indexOf('/collections/')===0;}
function isFiltered(){return location.search.indexOf('filter.p.tag')>-1;}
function stripFilter(){
 var kept=[],parts=location.search.replace(/^\?/,'').split('&');
 for(var i=0;i<parts.length;i++){
  var p=parts[i];
  if(!p)continue;
  if(p.indexOf('filter.p.tag=')===0)continue;
  if(p.indexOf('br_all=')===0)continue;
  kept.push(p);
 }
 return location.pathname+(kept.length?'?'+kept.join('&'):'');
}
function esWrite(v){
 try{
  var exp=String(Date.now()+ES_TTL);
  if(!v){
   localStorage.setItem(ES_PRE,JSON.stringify({value:'',expires:exp}));
   localStorage.setItem(ES_TAG,JSON.stringify({value:'',expires:exp}));
   return;
  }
  localStorage.setItem(ES_PRE,JSON.stringify({value:v.y+ESD+v.mk+ESD+v.md+ESD,expires:exp}));
  var t=v.tag||tagFor(v);
  localStorage.setItem(ES_TAG,JSON.stringify({value:(t?t+'+':'')+UNI,expires:exp}));
 }catch(e){}
}
function esRead(){
 try{
  var raw=localStorage.getItem(ES_PRE);if(!raw)return null;
  var o=JSON.parse(raw);if(!o||!o.value)return null;
  if(o.expires&&Number(o.expires)<Date.now())return null;
  var p=o.value.split(ESD);
  if(p.length<3||!p[0]||!p[1]||!p[2])return null;
  return {y:parseInt(p[0],10),mk:p[1],md:p[2]};
 }catch(e){return null;}
}
function setV(v){try{if(!v.tag)v.tag=tagFor(v);localStorage.setItem(LSKEY,JSON.stringify(v));}catch(e){}esWrite(v);}
function clearV(){
 try{localStorage.removeItem(LSKEY);}catch(e){}
 esWrite(null);
 track('garage_cleared');
 if(onCollection()&&isFiltered()){location.replace(stripFilter());return;}
 render();close();
}
function sameV(a,b){return !!a&&!!b&&String(a.y)===String(b.y)&&a.mk===b.mk&&a.md===b.md;}
function syncFromApp(){
 var a=esRead();if(!a)return false;
 var v=getV();
 if(sameV(v,a))return false;
 var url=span(SEL,a.mk,a.md,a.y);
 if(!url)return false;
 setV({y:a.y,mk:a.mk,md:a.md,url:url,ts:Date.now()});
 return true;
}
function filtered(url,v){
 if(isVehiclePath(url))return url;
 var t=(v&&v.tag)||tagFor(v);if(!t)return url;
 return url+(url.indexOf('?')<0?'?':'&')+'filter.p.tag='+encodeURIComponent(t)+'&filter.p.tag='+UNI;
}
function refilter(){
 if(!onCollection()||!isFiltered())return false;
 if(isVehiclePath(location.pathname))return false;
 var v=getV();if(!v)return false;
 var want=filtered(stripFilter(),v);
 if(want!==location.pathname+location.search){location.replace(want);return true;}
 return false;
}
/* Strips tag filters off vehicle collection URLs — covers old bookmarks, links shared
   before v9.1, and the easysearch app writing its own filtered URLs. */
function cleanVehicleUrl(){
 if(!onCollection()||!isVehiclePath(location.pathname)||!isFiltered())return false;
 location.replace(stripFilter());
 return true;
}
function watchApp(){
 var last=localStorage.getItem(ES_PRE);
 setInterval(function(){
  var cur=localStorage.getItem(ES_PRE);
  if(cur===last)return;
  last=cur;
  if(syncFromApp()){if(!refilter())render();}
 },700);
 window.addEventListener('storage',function(e){if(e.key===ES_PRE&&syncFromApp()){if(!refilter())render();}});
}
function trampoline(){
 if(location.pathname!=='/collections/all')return;
 var qs=location.search;
 if(qs.indexOf('filter.p.tag')<0)return;
 var tags=[],parts=qs.replace(/^\?/,'').split('&');
 for(var i=0;i<parts.length;i++){
  var kv=parts[i].split('=');
  if(kv[0]==='filter.p.tag')tags.push(decodeURIComponent(kv[1]||''));
 }
 var esi=null;
 for(var j=0;j<tags.length;j++)if(/-esi\d+$/.test(tags[j])){esi=tags[j];break;}
 if(!esi)return;
 var url=null,v=getV();
 if(v&&((v.tag||tagFor(v))===esi))url=v.url;
 if(!url){
  for(var mk in TAGS){
   for(var md in TAGS[mk]){
    var sp=TAGS[mk][md];
    for(var k=0;k<sp.length;k++){
     if(sp[k][2]===esi){url=span(SEL,mk,md,sp[k][0]);break;}
    }
    if(url)break;
   }
   if(url)break;
  }
 }
 if(url)location.replace(isVehiclePath(url)?url:url+qs);
}
function vis(el){return !!(el&&(el.offsetWidth||el.offsetHeight||(el.getClientRects&&el.getClientRects().length)));}
function headerEl(){var b=document.getElementById('BrVehBtn');if(b&&b.closest){var h=b.closest('header');if(h)return h;}return document.querySelector('header');}
var css=document.createElement('style');
css.textContent='.br-veh{align-items:stretch;margin-right:.85rem;border-radius:3px;line-height:1;flex:0 0 auto}.br-veh[data-has-vehicle]{border:1px solid #b9b4ac}.br-veh-main{display:inline-flex;align-items:center;gap:.4rem;background:#d93228;color:#fff;border:0;border-radius:3px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;padding:.62rem .95rem;line-height:1;white-space:nowrap}.br-veh-main:hover{filter:brightness(1.08)}.br-veh[data-has-vehicle] .br-veh-main{background:transparent;color:inherit;flex-direction:column;align-items:flex-start;gap:.18rem;padding:.42rem .5rem .42rem .7rem;filter:none}.br-veh[data-has-vehicle] .br-veh-main:hover .br-veh-name{color:#d93228}.br-veh-verified{display:inline-flex;align-items:center;gap:.25rem;color:#d93228;font-size:9px;font-weight:700;letter-spacing:.14em}.br-veh-name{font-size:12px;font-weight:700;letter-spacing:.04em;white-space:nowrap}.br-veh-x{display:none;background:none;border:0;color:#8a8d96;cursor:pointer;font-family:inherit;font-size:16px;line-height:1;padding:0 .6rem;align-items:center}.br-veh[data-has-vehicle] .br-veh-x{display:inline-flex}.br-veh-x:hover{color:#d93228}#BrHomeBar{background:#101014;color:#f1e8e3;display:flex;align-items:center;justify-content:center;gap:.9rem;flex-wrap:wrap;padding:.7rem 1rem;border-bottom:1px solid #23262e}#BrHomeBar .brh-btn{display:inline-flex;align-items:center;gap:.45rem;background:#d93228;color:#fff;border:0;border-radius:3px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;padding:.62rem 1rem;line-height:1}#BrHomeBar .brh-btn:hover{filter:brightness(1.08)}#BrHomeBar .brh-link{background:none;border:0;color:#8a8d96;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase}#BrHomeBar .brh-link:hover{color:#d93228}#BrHomeBar .brh-hint{color:#9a9da6;font-size:13px;cursor:pointer}#BrHomeBar .brh-check{color:#d93228}#BrHomeBar .brh-veh{font-weight:700;letter-spacing:.04em;text-transform:uppercase;font-size:12px}#BrHomeBar a{color:#fff;text-decoration:none}#BrHomeBar a:hover{color:#d93228}@media(max-width:700px){#BrHomeBar .brh-hint{display:none}#BrHomeBar{gap:.6rem;padding:.6rem .75rem;font-size:12px}}#BrYmmPanel{position:fixed;left:0;right:0;z-index:998;background:#101014;border-bottom:1px solid #23262e;color:#f1e8e3;overflow:hidden;max-height:0;transition:max-height .22s ease}#BrYmmPanel[data-open]{max-height:340px}#BrYmmPanel .brp-inner{max-width:720px;margin:0 auto;padding:1.1rem 1.25rem 1.3rem}#BrYmmPanel .brp-head{text-align:center;margin:0 0 .85rem}#BrYmmPanel .brp-title{margin:0;color:#fff;font-size:14px;font-weight:700;letter-spacing:.11em;text-transform:uppercase}#BrYmmPanel .brp-sub{margin:.25rem 0 0;color:#9a9da6;font-size:12px}#BrYmmPanel .brp-remove{display:block;margin:.8rem auto 0;background:none;border:0;color:#8a8d96;font-family:inherit;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}#BrYmmPanel .brp-remove[hidden]{display:none!important}#BrYmmPanel .brp-remove:hover{color:#d93228}.br-ymm-sel select{width:100%;margin:0 0 .55rem;background:#1a1c23;border:1px solid #2c2f3a;color:#f1e8e3;border-radius:4px;padding:.75rem .9rem;font-size:14px;font-weight:600;letter-spacing:.03em;min-height:46px}.br-ymm-sel select:disabled{opacity:.45}.br-ymm-sel select:focus{border-color:#d93228;outline:none;box-shadow:0 0 0 2px rgba(217,50,40,.25)}.br-ymm-sel .brm-go{width:100%;background:#d93228;color:#fff;border:0;border-radius:4px;padding:.8rem 1rem;font-size:13px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer}.br-ymm-sel .brm-go:disabled{background:#3a3d47;cursor:not-allowed}@media(min-width:750px){.br-ymm-sel{display:grid;grid-template-columns:1fr 1fr 1fr auto;gap:.55rem}.br-ymm-sel select{margin:0}.br-ymm-sel .brm-go{width:auto;padding-left:1.5rem;padding-right:1.5rem}}';
document.head.appendChild(css);
function mount(box,cta){
 if(box.getAttribute('data-brm-ready'))return;box.setAttribute('data-brm-ready','1');
 box.className=(box.className+' br-ymm-sel').replace(/^ /,'');
 box.innerHTML='<select data-brm-year><option value="">Year</option></select><select data-brm-make disabled><option value="">Make</option></select><select data-brm-model disabled><option value="">Model</option></select><button type="button" class="brm-go" disabled>'+(cta||'See What Fits')+'</button>';
 var yS=box.querySelector('[data-brm-year]'),mkS=box.querySelector('[data-brm-make]'),mdS=box.querySelector('[data-brm-model]'),go=box.querySelector('.brm-go');
 var years=[],mk,md,i;
 for(mk in SEL)for(md in SEL[mk])for(i=0;i<SEL[mk][md].length;i++){for(var y=SEL[mk][md][i][0];y<=SEL[mk][md][i][1];y++)if(years.indexOf(y)<0)years.push(y);}
 years.sort(function(a,b){return b-a;});
 for(i=0;i<years.length;i++)yS.add(new Option(years[i],years[i]));
 function ok(sp,y){for(var j=0;j<sp.length;j++)if(y>=sp[j][0]&&y<=sp[j][1])return true;return false;}
 function fill(s,items,label){s.innerHTML='<option value="">'+label+'</option>';items.sort();for(var j=0;j<items.length;j++)s.add(new Option(items[j],items[j]));s.disabled=!items.length;}
 yS.addEventListener('change',function(){var y=parseInt(yS.value,10),makes=[];if(y)for(var a in SEL)for(var b in SEL[a])if(ok(SEL[a][b],y)&&makes.indexOf(a)<0)makes.push(a);fill(mkS,makes,'Make');fill(mdS,[],'Model');go.disabled=true;track('ymm_search_started');});
 mkS.addEventListener('change',function(){var y=parseInt(yS.value,10),a=mkS.value,models=[];if(a)for(var b in SEL[a])if(ok(SEL[a][b],y))models.push(b);fill(mdS,models,'Model');go.disabled=true;});
 mdS.addEventListener('change',function(){go.disabled=!mdS.value;});
 go.addEventListener('click',function(){var y=parseInt(yS.value,10),a=mkS.value,b=mdS.value;if(!y||!a||!b)return;var url=span(SEL,a,b,y);if(!url)return;var v={y:y,mk:a,md:b,url:url,tag:span(TAGS,a,b,y),ts:Date.now()};setV(v);track('vehicle_selected',{vehicle_year:y,vehicle_make:a,vehicle_model:b,destination:url});window.location.href=filtered(url,v);});
}
function navEl(h){
 if(!h)return null;
 var navs=h.querySelectorAll('nav');var best=null,bw=0;
 for(var i=0;i<navs.length;i++){if(!vis(navs[i]))continue;var r=navs[i].getBoundingClientRect();if(r.width>bw){bw=r.width;best=navs[i];}}
 return best;
}
function logoEl(h){if(!h)return null;var a=h.querySelector('a[href="/"]');return a&&vis(a)?a:null;}
function layout(){
 var wrap=document.getElementById('BrVehBtn'),bar=document.getElementById('BrHomeBar');
 if(!bar)return;
 var v=getV();
 if(!wrap){bar.style.display='flex';return;}
 if(window.matchMedia('(max-width:1023px)').matches){wrap.style.display='';bar.style.display='flex';return;}
 wrap.style.visibility='hidden';wrap.style.display='inline-flex';
 var h=headerEl(),nav=navEl(h),logo=logoEl(h);
 var wr=wrap.getBoundingClientRect();
 var fits=true;
 if(nav){var nr=nav.getBoundingClientRect();if(nr.right>wr.left-GAP)fits=false;}
 if(logo){
  var lr=logo.getBoundingClientRect();
  if(lr.left<2)fits=false;
  if(wr.left<lr.right+GAP)fits=false;
 }
 if(h&&h.scrollWidth>h.clientWidth+2)fits=false;
 if(wr.left<2||wr.right>(window.innerWidth-2))fits=false;
 wrap.style.visibility='';
 if(fits){wrap.style.display='inline-flex';bar.style.display=v?'none':'flex';}
 else{wrap.style.display='none';bar.style.display='flex';}
}
function render(){
 var v=getV();
 var wrap=document.getElementById('BrVehBtn');
 if(wrap){
  if(v){
   wrap.setAttribute('data-has-vehicle','');
   wrap.innerHTML='<button type="button" class="br-veh-main" data-brm-toggle><span class="br-veh-verified">&#10003; Verified</span><span class="br-veh-name">'+v.y+' '+v.mk+' '+v.md+'</span></button><button type="button" class="br-veh-x" data-brm-clear aria-label="Remove vehicle">&times;</button>';
  }else{
   wrap.removeAttribute('data-has-vehicle');
   wrap.innerHTML='<button type="button" class="br-veh-main" data-brm-toggle><span>+</span> Add a Vehicle</button>';
  }
 }
 var bar=document.getElementById('BrHomeBar');
 var hh=headerEl();
 var host=(hh&&hh.closest)?(hh.closest('[id^="shopify-section"]')||hh):hh;
 if(host&&host.parentNode){
  if(!bar){bar=document.createElement('div');bar.id='BrHomeBar';host.parentNode.insertBefore(bar,host.nextSibling);}
  else if(bar.previousElementSibling!==host){host.parentNode.insertBefore(bar,host.nextSibling);}
 }
 if(bar){
  if(v)bar.innerHTML='<span><span class="brh-check">&#10003;</span> Shopping for <a class="brh-veh" href="'+filtered(v.url,v)+'">'+v.y+' '+v.mk+' '+v.md+'</a></span><button type="button" class="brh-link" data-brm-toggle>Change</button><button type="button" class="brh-link" data-brm-clear>Remove</button>';
  else bar.innerHTML='<button type="button" class="brh-btn" data-brm-toggle><span>+</span> Add a Vehicle</button><span class="brh-hint" data-brm-toggle>Enter your Year, Make, and Model to see what fits your truck.</span>';
 }
 layout();
}
function panel(){
 var p=document.getElementById('BrYmmPanel');
 if(!p){p=document.createElement('div');p.id='BrYmmPanel';p.innerHTML='<div class="brp-inner"><div class="brp-head"><p class="brp-title">What Fits My Truck?</p><p class="brp-sub">Select your year, make, and model to see everything that fits.</p></div><div data-brm-mount></div><button type="button" class="brp-remove" data-brm-clear hidden>Remove Selected Vehicle</button></div>';document.body.appendChild(p);mount(p.querySelector('[data-brm-mount]'),'See What Fits');}
 return p;
}
function position(){var p=document.getElementById('BrYmmPanel');if(!p||!p.hasAttribute('data-open'))return;var h=headerEl();p.style.top=(h?Math.max(0,h.getBoundingClientRect().bottom):0)+'px';}
function open(){var p=panel(),h=headerEl();p.style.top=(h?Math.max(0,h.getBoundingClientRect().bottom):0)+'px';p.setAttribute('data-open','');var rm=p.querySelector('.brp-remove');if(rm)rm.hidden=!getV();track('ymm_selector_opened');}
function close(){var p=document.getElementById('BrYmmPanel');if(p)p.removeAttribute('data-open');}
function toggle(){var p=document.getElementById('BrYmmPanel');if(p&&p.hasAttribute('data-open'))close();else open();}
function applyFilter(){
 var v=getV();if(!v)return;
 if(!onCollection())return;
 if(isVehiclePath(location.pathname))return;
 if(isFiltered()||location.search.indexOf('br_all')>-1)return;
 var path=location.pathname.toLowerCase();
 for(var i=0;i<NOFILTER.length;i++)if(path.indexOf(NOFILTER[i])>-1)return;
 if(!(v.tag||tagFor(v)))return;
 location.replace(filtered(location.pathname+location.search,v));
}
document.addEventListener('click',function(e){
 var t=e.target;if(!t||!t.closest)return;
 if(t.closest('[data-brm-clear]')){e.preventDefault();clearV();return;}
 if(t.closest('[data-brm-toggle]')){e.preventDefault();toggle();return;}
 var p=document.getElementById('BrYmmPanel');
 if(p&&p.hasAttribute('data-open')&&!t.closest('#BrYmmPanel')&&!t.closest('#BrVehBtn')&&!t.closest('#BrHomeBar'))close();
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
var rt=null;
function onResize(){position();if(rt)clearTimeout(rt);rt=setTimeout(layout,120);}
window.addEventListener('scroll',position,{passive:true});
window.addEventListener('resize',onResize);
syncFromApp();
trampoline();
cleanVehicleUrl();
applyFilter();
function init(){
 var v=getV();
 if(v)esWrite(v);
 render();
 watchApp();
 var inl=document.querySelectorAll('[data-br-ymm-inline]');
 for(var i=0;i<inl.length;i++)mount(inl[i],inl[i].getAttribute('data-cta'));
}
function boot(){
 init();
 if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){layout();});
 window.addEventListener('load',function(){layout();});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
(function(){var s=document.createElement('style');s.textContent='.header-section.header-transparent ~ #BrHomeBar{display:none!important}';(document.head||document.documentElement).appendChild(s);})();